import { render, staticRenderFns } from "./baseBtraExtra.vue?vue&type=template&id=5494481c"
import script from "./baseBtraExtra.vue?vue&type=script&lang=js"
export * from "./baseBtraExtra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports